import React, { useEffect, useState } from 'react';
import { useStore } from 'hooks';
import { ProductService } from 'services';
import Menu from 'components/menu';
import Table from 'components/table';
import Actions from 'components/table/actions';
import Modal from 'components/modal';
import Product from 'components/modal/product';
import { Input } from 'components/ui/form';
import { normalizeProductGroup } from 'helpers/utils';
import styles from './products.module.scss';

const DEFAULT_LIMIT = 20;

const ProductsPage = () => {
  const { reload, setUser, setLoading, setReload } = useStore();
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(DEFAULT_LIMIT);
  const [searchQuery, setSearchQuery] = useState('');
  const [edit, setEdit] = useState(null);
  const [modal, setModal] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function fetchProducts() {
      setLoading(true);
      const params = { page, limit, 'order[id]': 'asc' };
      if (searchQuery.trim()) {
        params.search = searchQuery.trim();
      }
      const response = await new ProductService({ setUser }).getProducts(params);
      setLoading(false);

      if (cancelled || !response) return;
      if (response.items != null) {
        setData(response.items);
        setCount(response.count ?? 0);
      }
    }

    fetchProducts();
    return () => { cancelled = true; };
  }, [reload, page, limit, searchQuery, setUser, setLoading]);

  const onOpenModal = () => setModal(true);

  const onCloseModal = (isReload = false) => {
    setEdit(null);
    setModal(false);
    if (isReload) {
      setReload();
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setPage(0);
  };

  const cells = [{
    name: 'ID',
    nowrap: true,
    renderField: 'id',
  }, {
    name: 'Название',
    renderField: 'name',
  }, {
    name: 'Код',
    nowrap: true,
    renderField: 'code',
  }, {
    name: 'Код ГНГ',
    nowrap: true,
    renderField: 'gng',
  }, {
    name: 'ETCIS',
    nowrap: true,
    renderField: 'etcis',
  }, {
    name: 'Группа',
    nowrap: true,
    onRender: item => normalizeProductGroup(item?.group),
  }, {
    name: '',
    right: true,
    nowrap: true,
    onRender: item => (
      <Actions
        data={[{
          name: 'edit',
          title: 'Открыть',
          onClick: () => {
            setEdit(item);
            setModal(true);
          },
        }]}
      />
    ),
  }];

  return (
    <>
      <div className={styles.menu}>
        <Menu onAdd={onOpenModal} />
      </div>
      <div className={styles.search}>
        <Input
          type="text"
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder="Поиск по названию, коду, ГНГ, ETCIS, группе"
        />
      </div>
      <div className={styles.table}>
        <Table
          cells={cells}
          data={data}
          count={count}
          page={page}
          limit={limit}
          onPageChange={({ selected }) => setPage(selected)}
          onLimitChange={(newLimit) => {
            setLimit(newLimit);
            setPage(0);
          }}
        />
      </div>
      {modal ? (
        <Modal closeBackground={false} onClose={onCloseModal}>
          <Product edit={edit} onClose={onCloseModal} />
        </Modal>
      ) : null}
    </>
  );
};

export default ProductsPage;
